import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';
import { useParams } from "react-router-dom";
import { render } from 'react-dom';
import API from '../../initialize/API.js';
import { initialize, RACEMANEGEMENT_HOSTNAME, organization_id, token, pm_token, show_devices } from '../../initialize/initialize.js';
import { fireEmergency, autoFireEmergency, sendLocation, stopLocation, getStatus, getStatusInterval, stopStatus } from '../common/common'
import { Link } from 'react-router-dom';
import { is_force, guest_name, phone_number, confirm_number, checkin_date, house_name, auto_track } from '../helpers/helpers.js';

import i18n from "./i18n"; // 言語データをインポート

//My compornent
import MapView from '../map/map_view.js';

//CSS
import '../../index.css';

// MUI
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import MapIcon from '@mui/icons-material/Map';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import SettingsIcon from '@mui/icons-material/Settings';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import { Toolbar } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
export const AutoTrackTriage = 99

// App 本体
export default function Main() {

  //言語
  const { lang } = useParams();
  const texts = i18n[lang] || i18n.main; // デフォルトは日本語

  // State
  const [center, setCenter] = React.useState([35.28167445342043, 139.67306039427112]);
  const isGlocal = texts.mode === "GLOCAL";
  const [style, setStyle] = useState(isGlocal ? 'mapbox://styles/mapbox/streets-v11' : 'mapbox://styles/i01210ml/clg571dks000501qna35qk8uh');
  const [devices, setDevices] = useState([]);
  const [online, setOnline] = useState();
  const [phone, setPhone] = useState(phone_number());
  const [email, setEmail] = useState();
  const [name, setName] = useState(guest_name());
  const [location, setLocation] = useState();
  const [lat, setLat] = useState(0);
  const [lon, setLon] = useState(0);
  const [triage, setTriage] = useState(auto_track() ? AutoTrackTriage : 0);
  const height = "40vh"
  const [caseNo, setCaseNo] = useState();
  const [status, setStatus] = useState(0);
  const [track, setTrack] = useState(true);
  const [accuracy, setAccuracy] = useState(9999);
  const [geoJson, setGeoJson] = useState(null);

  const param = pm_token ? `?org_id=${organization_id}&public_token=${token}&public_map_token=${pm_token}` : `?org_id=${organization_id}&public_token=${token}`;
  const useWs = show_devices();

  //初期処理
  useEffect(() => {
    initialize(setDevices, setOnline, useWs, setGeoJson);
  }, []);

  //定期送信処理
  useEffect(() => {
    sendLocation(RACEMANEGEMENT_HOSTNAME, token, triage, caseNo, lat, lon, organization_id, phone, name, location, track);
    return () => stopLocation();
  }, [caseNo, lat, lon, track]);

  //Auto Track
  useEffect(() => {
    //まだ通報IDがなく、誤差が50m以下の場合に位置情報を送信
    if (!caseNo && auto_track() && confirm_number() && accuracy < 50) {
      setTriage(AutoTrackTriage);
      let message = location;
      if (confirm_number()) {
        message = confirm_number() + ":" + checkin_date() + ":" + house_name() + ":" + location
      }
      autoFireEmergency(RACEMANEGEMENT_HOSTNAME, token, AutoTrackTriage, caseNo, lat, lon, organization_id, phone, name, message, setCaseNo, texts, email);
    }
  }, [accuracy]);

  //通常の送信
  let onClick = () => {
    let message = location;
    if (confirm_number()) {
      message = confirm_number() + ":" + checkin_date() + ":" + house_name() + ":" + location
    }
    fireEmergency(RACEMANEGEMENT_HOSTNAME, token, triage, caseNo, lat, lon, organization_id, phone, name, message, setCaseNo, texts, email);

    //受付状況更新
  }

  //状態の更新
  useEffect(() => {
    getStatusInterval(RACEMANEGEMENT_HOSTNAME, token, caseNo, organization_id, setStatus, triage);
    return () => stopStatus();
  }, [caseNo]);

  // 日本時間の営業時間チェック
  useEffect(() => {
    if (texts.business_time_msg) {
      const nowJST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" })
      );
      const hour = nowJST.getHours();
      if (hour < 9 || hour >= 22) {
        alert(texts.business_time_msg);
      }
    }
  }, [texts]);

  let reset = () => {
    setCaseNo(null);
    setStatus(0);
    alert(texts.resetNo);
    stopLocation();
    stopStatus();
  }

  let handleChangeTriage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTriage(event.target.value)

    if ((event.target.value == 5) && (texts.selfAidMsg != "")) {
      alert(texts.selfAidMsg)
    }
  }

  const statusMessages = {
    0: { text: "受付されました。このままお待ちください", severity: "info" },
    1: { text: "完了しました", severity: "success" },
    2: { text: "対応が開始されました", severity: "warning" }
  };

  return (
    <>
      <Toolbar >
        <div className={"Navigation"}>
          {texts.title}
          <span className="language-switcher"><Link to={`/${lang.replace(/_en$/, '')}` + param} style={{ color: 'white' }}>JP</Link>&nbsp;|&nbsp;<Link to={`/${lang.replace(/_en$/, '')}_en` + param} style={{ color: 'white' }}>EN</Link></span>
        </div>
      </Toolbar>
      <Grid container >
        <Grid item xs={12}>
          <MapView center={center} style={style} online={online} height={height} setStyle={setStyle} setLat={setLat} setLon={setLon} devices={devices} setAccuracy={setAccuracy} useWs={useWs} geoJson={geoJson} isGlocal={isGlocal} lang={lang} />
        </Grid>

        <Grid item xs={12} className={"form"}>
          <div style={{ height: '30px', margin: 'auto' }}></div>
          <div style={{ width: '80%', margin: 'auto' }}>
            {texts.reportNoTitle} {caseNo ? caseNo : texts.reportNo}&nbsp;&nbsp;
            <Button color="info" variant="outlined" onClick={reset}>{texts.newReport}</Button>
            &nbsp;&nbsp;{texts.autoRefresh}<Checkbox defaultChecked onClick={() => setTrack(!track)} />
          </div>
        </Grid>

        {(caseNo && triage != AutoTrackTriage) && (
          <Grid item xs={12} className={"form"}>
            <div style={{ height: '30px', margin: 'auto' }}></div>
            <div style={{ width: '80%', margin: 'auto' }}>
              {"【受付状況】"}
              <Box display="flex" alignItems="center" gap={2} mt={1}>
                <Box flex={4}>
                  {status in statusMessages ? (
                    <Alert severity={statusMessages[status].severity}>
                      {statusMessages[status].text}
                    </Alert>
                  ) : (
                    <Alert severity="error">不明なステータスです</Alert>
                  )}
                </Box>
                <Box flex={1}>
                  <Button
                    variant="outlined"
                    fullWidth
                    size="large"
                    onClick={() => getStatus(RACEMANEGEMENT_HOSTNAME, token, caseNo, organization_id, setStatus, triage)} // 必要に応じて関数追加
                  >
                    更新
                  </Button>
                </Box>
              </Box>
            </div>
          </Grid>
        )}

        {confirm_number() && (
          <Grid item xs={12} className={"form"}>
            <div style={{ height: '30px', margin: 'auto' }}></div>
            <div style={{ width: '80%', margin: 'auto' }}>
              {"【予約情報】"}
              <div>{"OTA予約番号:"}{confirm_number()}</div>
              <div>{"宿泊開始日:"}{checkin_date()}</div>
              <div>{"施設名:"}{house_name()}</div>
            </div>
          </Grid>
        )}



        <Grid item xs={12} className={"form"}>
          <div style={{ height: '30px', margin: 'auto' }}></div>
          <div style={{ width: '80%', margin: 'auto' }}>
            {texts.triageTitle}
          </div>
        </Grid>

        <Grid item xs={12} className={"form"}>
          <div style={{ width: '80%', margin: 'auto' }}>
            <select className={'triage'} onChange={handleChangeTriage} defaultValue={0}>
              <option value="0">{texts.triage0}</option>
              {texts.triage3 && <option value="3">{texts.triage3}</option>}
              {texts.triage4 && <option value="4">{texts.triage4}</option>}
              {texts.triage5 && <option value="5">{texts.triage5}</option>}
              {texts.triage6 && <option value="6">{texts.triage6}</option>}
              {texts.triage7 && <option value="7">{texts.triage7}</option>}
              {texts.triage8 && <option value="8">{texts.triage8}</option>}
              {texts.triage9 && <option value="9">{texts.triage9}</option>}
            </select>
          </div>
        </Grid>

        <Grid item xs={12} className={"form"}>
          <div style={{ height: '30px', margin: 'auto' }}></div>
          <div style={{ width: '80%', margin: 'auto' }}>
            {texts.bibTitle}
          </div>
        </Grid>

        <Grid item xs={12} className={"form"}>
          <div style={{ width: '80%', margin: 'auto' }}>
            <TextField fullWidth id="outlined-basic1" label={texts.bibInput} variant="outlined" onChange={(event) => setLocation(event.target.value)} />
          </div>
        </Grid>

        <Grid item xs={12} className={"form"}>
          <div style={{ height: '30px', margin: 'auto' }}></div>
          <div style={{ width: '80%', margin: 'auto' }}>
            {texts.inputPhoneTitle}
          </div>
        </Grid>
        <Grid item xs={12} className={"form"}>
          <div style={{ width: '80%', margin: 'auto' }}>
            <TextField fullWidth id="outlined-basic2" label={texts.inputPhone} variant="outlined" value={phone} onChange={(event) => setPhone(event.target.value)} />
          </div>
        </Grid>

        {texts.inputEmail && (
          <>
            <Grid item xs={12} className={"form"}>
              <div style={{ height: '30px', margin: 'auto' }}></div>
              <div style={{ width: '80%', margin: 'auto' }}>
                {texts.inputEmailTitle}
              </div>
            </Grid>
            <Grid item xs={12} className={"form"}>
              <div style={{ width: '80%', margin: 'auto' }}>
                <TextField fullWidth id="outlined-basic2" label={texts.inputEmail} variant="outlined" onChange={(event) => setEmail(event.target.value)} />
              </div>
            </Grid>
          </>
        )}


        <Grid item xs={12} className={"form"}>
          <div style={{ height: '30px', margin: 'auto' }}></div>
          <div style={{ width: '80%', margin: 'auto' }}>
            {texts.nameTitle}
          </div>
        </Grid>

        <Grid item xs={12} className={"form"}>
          <div style={{ width: '80%', margin: 'auto' }}>
            <TextField fullWidth id="outlined-basic2" label={texts.nameInput} variant="outlined" value={name} onChange={(event) => setName(event.target.value)} />
          </div>
        </Grid>

        <div style={{ height: '80px', margin: 'auto' }}></div>
        <Grid item xs={12} className={"form"}>
          <div style={{ width: '80%', margin: 'auto' }}>
            {!texts.disp_accurate && (
              <>
                <p style={{ fontWeight: 'bold' }}>
                  {texts.mapTitle}{texts.mapAccurate}{Math.round(accuracy)} meter ({texts.mapAccurate2})
                </p>
                <br />
              </>
            )}
            {texts.service1}&nbsp;<a href={texts.kiyaku_url} target="_blank" rel="noopener noreferrer">{texts.serviceLink}</a>{texts.service2}
          </div>
        </Grid>


        <Grid item xs={12} className={"form"}>
          <div style={{ width: '80%', margin: 'auto' }}>
            <Button fullWidth disabled={accuracy > 50 && is_force() != 1} color="error" variant="contained" endIcon={<SendIcon />} onClick={onClick}>{texts.callStaff}</Button>
          </div>
          <div style={{ width: '80%', margin: 'auto' }}>
            {texts.position}
          </div>
          <div style={{ height: '30px', margin: 'auto' }}></div>
        </Grid>
      </Grid>
    </>
  );
}
